<template>
  <div
    v-show="targetContainer && markers && markers.length && duration > 0"
    class="timeline-markers-overlay"
  >
    <div
      v-for="marker in markers"
      :key="marker.id"
      class="marker-tick"
      :class="markerClass(marker)"
      :style="{ left: calcLeft(marker.time) }"
      @click.stop="$emit('marker-click', marker)"
      @mouseenter="$emit('marker-hover', { marker, event: $event })"
      @mouseleave="$emit('marker-leave')"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'TimelineMarkers',
  props: {
    markers:        { type: Array,  default: () => [] },
    currentTime:    { type: Number, default: 0 },
    duration:       { type: Number, default: 0 },
    targetContainer: { default: null }
  },
  mounted() {
    this.attachToProgress();
  },
  watch: {
    targetContainer() {
      this.attachToProgress();
    }
  },
  beforeDestroy() {
    // Vue 2 has no Teleport: remove the node moved into Plyr's controls.
    if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
  },
  methods: {
    attachToProgress() {
      if (this.targetContainer && this.$el) {
        this.targetContainer.appendChild(this.$el);
      }
    },
    calcLeft(time) {
      if (!this.duration || this.duration <= 0) return '0%';
      const pct = Math.min(100, Math.max(0, (time / this.duration) * 100));
      return pct + '%';
    },
    markerClass(m) {
      return {
        'marker-note':    m.type === 'note',
        'marker-survey':  m.type === 'survey',
        'marker-answered': m.type === 'survey' && m.data && m.data.answered
      };
    }
  }
};
</script>

<style scoped>
.timeline-markers-overlay {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  height: 16px;
  pointer-events: none;
  z-index: 20;
}

.marker-tick {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: auto;
  cursor: pointer;
  width: 4px;
  height: 14px;
  border-radius: 2px;
  transition: height 0.15s ease, width 0.15s ease, box-shadow 0.15s ease;
}

.marker-note {
  background: #FFD93D;
  box-shadow: 0 0 3px rgba(0,0,0,.6);
}
.marker-note:hover {
  width: 6px;
  height: 18px;
  box-shadow: 0 0 8px rgba(255,217,61,.9);
}

.marker-survey {
  background: #20B8D6;
  box-shadow: 0 0 3px rgba(0,0,0,.6);
}
.marker-survey:hover {
  width: 6px;
  height: 18px;
  box-shadow: 0 0 8px rgba(32,184,214,.9);
}

.marker-answered {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #20B8D6;
  border: 1.5px solid #fff;
  box-shadow: 0 0 4px rgba(0,0,0,.5);
}
.marker-answered:hover {
  width: 12px;
  height: 12px;
  box-shadow: 0 0 8px rgba(32,184,214,.9);
}
</style>

<style>
.plyr__progress, .plyr__controls { overflow: visible !important; }
</style>
